"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomNameValidation = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const react_query_1 = require("@tanstack/react-query");
const react_1 = tslib_1.__importDefault(require("react"));
function toSimilarityString(s) {
    return s.toLowerCase().replace(/[-_]/g, '').trim();
}
function useCustomNameValidation(queryKey, similar, func, existingNameForUpdate) {
    const queryFn = (0, catalog_core_1.useRestFnNoParams)(func);
    const { data } = (0, react_query_1.useQuery)(queryKey, { queryFn });
    return react_1.default.useCallback((current, max) => {
        const trimmedCurrent = current.trim();
        const existing = new Set(data === null || data === void 0 ? void 0 : data.map(({ name }) => toSimilarityString(name !== null && name !== void 0 ? name : '')));
        const message = `${catalog_messages_1.Formatters.formatCount(trimmedCurrent.length)} / ${catalog_messages_1.Formatters.formatCount(max)}`;
        if (trimmedCurrent.length > max) {
            return {
                valid: false,
                message,
            };
        }
        if (existingNameForUpdate) {
            if (trimmedCurrent !== existingNameForUpdate && existing.has(toSimilarityString(trimmedCurrent))) {
                return {
                    valid: false,
                    message: similar,
                };
            }
        }
        else {
            if (existing.has(toSimilarityString(trimmedCurrent))) {
                return {
                    valid: false,
                    message: similar,
                };
            }
        }
        return { message };
    }, [data, similar, existingNameForUpdate]);
}
exports.useCustomNameValidation = useCustomNameValidation;
//# sourceMappingURL=useCustomNameValidation.js.map